// extracted by mini-css-extract-plugin
export var cartContainer = "_mt-4";
export var gray = "_mt-1";
export var itemContainer = "_mt-2";
export var itemDetails = "_mt-3";
export var strong = "_mt-0";